var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":_vm.$style.login}},[_c('Header',{attrs:{"nav":"false","center":"false"}}),_vm._v(" "),_c('div',{class:_vm.$style.auth},[_c('h2',[_vm._v("Please Login")]),_vm._v(" "),_c('button',{staticClass:"btn",on:{"click":_vm.signIn}},[_vm._v("Continue With Google")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7569cf94","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login/index.vue
// module id = null
// module chunks = 